import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileText, Calculator, FlaskConical, History, Shield, User } from "lucide-react";
import { useAuth } from "@/App";

export const BottomNav = () => {
  const { user } = useAuth();

  const navItems = [
    { to: "/", icon: LayoutDashboard, label: "Today" },
    { to: "/protocols", icon: FileText, label: "Protocols" },
    { to: "/calculator", icon: Calculator, label: "Calc" },
    { to: "/vials", icon: FlaskConical, label: "Vials" },
    { to: "/history", icon: History, label: "History" },
    { to: "/profile", icon: User, label: "Profile" },
  ];

  // Add Admin tab for admin users
  if (user?.is_admin) {
    navItems.push({ to: "/admin", icon: Shield, label: "Admin" });
  }

  return (
    <nav className="bottom-nav" data-testid="bottom-navigation">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `bottom-nav-item ${isActive ? "active" : ""}`}
          data-testid={`nav-${item.label.toLowerCase()}`}
          end={item.to === "/"}
        >
          <item.icon size={22} strokeWidth={1.5} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;
